import { OptionType } from "../../shared/components/BaseAsyncPaginate";
import { createLoadOptions } from "../../service/createLoadOptions";
import {  getPaginatedByNameStates } from "./state-service";
import {
  State,
} from "../models/response/get-states-response";

const statesMapper = (spec: State): OptionType => ({
  value: spec?.abbr,
  label: `${spec?.name} (${spec?.abbr})`,
});


export const loadStates = (countryId?: number) =>
  createLoadOptions(
    (page, perPage, search) =>
      getPaginatedByNameStates({
        page,
        perPage,
        searchQuery: search,
        countryId,
      }),
    statesMapper
  );
